module.exports = __webpack_public_path__ + "img/zhengce.fb4f7d76.png";